module.exports = __webpack_public_path__ + "img/svg.7f777916.svg";